import * as z from "zod";

export const voucherSchema = z.object({
  voucherType: z.object(
    { value: z.string(), label: z.string() },
    { message: "Tipo de vale es requerido" },
  ),
  voucherDate: z.date({
    message: "Fecha de vale es requerido",
  }),
  zone: z.string({ message: "Zona es requerida" }),
  storage: z.object(
    { value: z.string(), label: z.string() },
    { message: "Bodega es requerida" },
  ),
  costCenter: z.object(
    { value: z.string(), label: z.string() },
    { message: "Centro de costo es requerido" },
  ),
  clientEntity: z.object(
    { value: z.string(), label: z.string() },
    { message: "Empresa mandante es requerida" },
  ),
  workOrder: z
    .object({ value: z.string(), label: z.string() })
    .optional()
    .nullable(),
  activityLabel: z.object(
    { value: z.string(), label: z.string() },
    { message: "Etiqueta de actividad es requerida" },
  ),
  productApplicant: z.object(
    { value: z.string(), label: z.string() },
    { message: "Solicitante es requerido" },
  ),
  equipmentInstance: z
    .object({ value: z.string(), label: z.string() })
    .optional(),
  products: z
    .array(
      z.object({
        id: z.string(),
        amount: z.number().or(z.string()),
        missingStock: z.number().optional(),
        comment: z.string().optional(),
        price: z.number().optional(),
      }),
    )
    .min(1, {
      message: "Debe haber al menos un producto en el vale",
    }),
  comment: z.string().optional(),
});
